import type { ChatImageProps } from './types/ChatImageTypes'

import './ChatImage.scss'
    
const ChatImage = ({ image, imageAllowInversion = false, isDarkTheme, backgroundColor, size, rounded, visibility }: ChatImageProps) => {
    const imageNeedsInversion = imageAllowInversion && isDarkTheme
    // without a size the image follows `--chat-image-size` (the same value as the status messages)
    const imageSize = size === undefined ? 'var(--chat-image-size)' : `${size}rem`
    const imagePadding = size === undefined ? 'calc(var(--chat-image-size) * 0.5)' : `${size * 0.5}rem`

    return (
        <div className="chat-image-container" style={{ visibility: visibility ? visibility : 'visible' }}>
            <div className="chat-image" style={{ backgroundColor, width: imageSize, height: imageSize, borderRadius: rounded ? '50%' : '0', padding: imagePadding }}>
                <img
                    className={`image ${imageNeedsInversion && 'invert-image'}`}
                    src={image}
                    alt='img'
                    style={{ backgroundColor, width: imageSize, height: imageSize, borderRadius: rounded ? '50%' : '0' }}
                />
            </div>
        </div>
    )
}

export default ChatImage
